import React from 'react';
import { Box } from '@mui/material';
import Header from './components/Header.tsx';
import HeroSection from './components/HeroSection.tsx';
import ApproachSection from './components/ApproachSection.tsx';
import ServicesSection from './components/ServicesSection.tsx';
import TestimonialsSection from './components/TestimonialsSection.tsx';
import CtaSection from './components/CtaSection.tsx';
import Footer from './components/Footer.tsx';
import ScrollToTopButton from './components/ScrollToTopButton.tsx';

function App() {
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Header />
      <HeroSection id="hero" />
      <ApproachSection id="approach" />
      <ServicesSection id="services" />
      <TestimonialsSection id="testimonials" />
      <CtaSection id="contact" />
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
}

export default App;
